var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9958 0.938477H2.13975C0.964606 0.938477 0.0117188 1.89505 0.0117188 3.07511V20.1657C0.0117188 21.3457 0.964606 22.3011 2.13975 22.3011H18.9958C20.1709 22.3011 21.1238 21.3457 21.1238 20.1657V3.07511C21.1238 1.89505 20.1709 0.938477 18.9958 0.938477ZM6.78631 17.8424H3.94606V8.70402H6.78631V17.8424ZM5.34715 7.5829C4.45075 7.5829 3.87116 6.94683 3.87116 6.16217C3.87116 5.37751 4.46917 4.74266 5.38399 4.74266C6.29881 4.74266 6.86121 5.35909 6.87963 6.16217C6.87963 6.94683 6.30004 7.5829 5.34715 7.5829ZM17.1576 17.8424H14.3161V12.7771C14.3161 11.6007 13.9059 10.7964 12.8782 10.7964C12.0923 10.7964 11.6256 11.3392 11.4206 11.8623C11.3457 12.0489 11.326 12.3105 11.326 12.5721V17.8424H8.48579V11.6192C8.48579 10.4796 8.44895 9.52674 8.41211 8.70402H10.8778L11.0092 9.97494H11.0645C11.439 9.37693 12.355 8.49772 13.8863 8.49772C15.7552 8.49772 17.1576 9.75023 17.1576 12.4407V17.8424Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked_In.7c94d9d567b15fd91dd15f13ff74bf43.svg";
export { ForwardRef as ReactComponent };